import { render, staticRenderFns } from "./FacestreamNtechlabSlot.vue?vue&type=template&id=901c6608&scoped=true"
import script from "./FacestreamNtechlabSlot.vue?vue&type=script&lang=js"
export * from "./FacestreamNtechlabSlot.vue?vue&type=script&lang=js"
import style0 from "./FacestreamNtechlabSlot.vue?vue&type=style&index=0&id=901c6608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901c6608",
  null
  
)

export default component.exports